// 西班牙语
export default {
  day: 'día',
  hour: 'hora',
  min: 'minuto',
  sesc: 'segundo',
  cancel: 'cancelar',
  confirm: 'confirmar',
  showMore: 'ver más',
  hideMore: 'ocultar',
  per_sale: { 
    title: 'La etapa de preventa termina en {days} días {hours} horas {mins} minutos {secs} segundos',
    title1: 'Para participar en la venta pública, primero es necesario completar el KYC',
    text: 'Comprar DLC',
    text1: 'Participar en KYC',
  },
  meau: {
    nav1: '¿Qué es DeepLink?',
    nav2: '¿Cómo comprar?',
    nav3: 'Libro blanco',
    nav4: 'PITCH DECK',
    nav5: 'FAQ',
    nav6: 'Research',
    add: 'Dirección:',
    link: 'Conectar billetera',
  },
  home: {
    intro: {
      title: 'DeepLink Public Sale',
      text: 'Cuenta regresiva para la primera etapa de la venta pública:',
      text1: 'El KYC actual ya ha comenzado',
      text2: 'Cuenta regresiva para el final de la Fase 5 de la Venta Pública',
      text3: 'Cuenta regresiva para la segunda etapa de la venta pública:',
      tip: 'Asegúrese de completar la verificación de KYC antes de comprar los tokens (DLC)',
      tip1: 'No compre repetidamente',
    },
    desc: {
      title: 'Deeplink consta de dos componentes: DeepLink Protocol y Deeplink Software',
      left: {
        text: '¡Todos los pagos se realizan con tokens de DeepLink!',
        text1: 'DeepLink Protocol es un protocolo de juegos en la nube de IA descentralizado,',
        text2: 'que combina la tecnología de IA y blockchain para ofrecer una tecnología de renderizado de juegos de ultra baja latencia. DeepLink Software es un software de control remoto de juegos y una plataforma de juegos en la nube desarrollada sobre DeepLink Protocol. Además, sobre la base de DeepLink Protocol se han desarrollado otros productos como una plataforma de cibercafé en la nube, una consola de juegos en la nube basada en blockchain y una consola de juegos portátil basada en blockchain.',
        text3: '100% Secure & Verified',
        btn1: 'Introducción al DeepLink Protocol',
        btn2: 'Introducción al DeepLink Software',
      },
      right: {
        text1: 'Public Sale está en curso',
        text1_1: 'KYC está en curso',
        text1_2: 'Public Sale Fase {pre_num1} está en curso',
        // text2: 'Precio de DLC: 1DLC={price}USDT, quedan {days} días {hour} horas {min} minutos',
        text2: 'Precio de DLC: 1DLC={price}USDT',
        text3: 'La {pre_num}ª Public Sale ha terminado',
        text4: 'La fase {pre_num1} está a punto de comenzar',
        text5: 'Public Sale está a punto de comenzar',
        text6: 'Por favor, complete el proceso de verificación de KYC antes de participar en la venta pública. Gracias por su cooperación.',
        // text7: 'Recompensa adicional del 10% de tokens en la fase actual, la recompensa se reducirá al 5% en la siguiente fase',
        text7: 'Recompensa adicional del 5% de tokens en la fase actual, sin recompensa adicional en la próxima fase',
        text8: 'Únete a la comunidad y participa en el sorteo para ganar 10,000 USDT y DLC',
        process: 'Completado {process}%',
        btn1: 'Participar en la verificación de KYC',
        btn1_1: 'KYC aprobado',
        text7_1: 'El KYC de la billetera actual está en revisión, por favor espere',
        text7_2: '¡El KYC de la billetera actual ha sido aprobado!',
        text7_3: 'El KYC de la billetera actual no fue aprobado, por favor vuelva a enviar!',
        text7_4: 'KYC de la billetera actual no enviado',
        btn2: 'Comprar DLC TOKEN',
        btn3: 'Enlace de recomendación del 5%',
        btn3_1: 'Enlace de recomendación del 10%',
        btn3_2: 'Enlace de recomendación del 15%',
        btn3_3: 'Enlace de recomendación del 20%',
      },
      success: 'El enlace ha sido copiado al portapapeles',
      error1: 'Por favor, conecte su billetera primero para obtener el código de invitación exclusivo y ganar recompensas',
      error2: 'Billetera no conectada, por favor conecte su billetera primero',
      error3: 'La verificación KYC está en proceso, espere a que se complete antes de realizar la compra',
      error4: 'La verificación KYC ha fallado, por favor, vuelva a enviar la información de verificación KYC para comprar',
      error5: 'Error al obtener la información de verificación KYC, por favor intente nuevamente más tarde',
      error6: 'Por favor, espere a que termine la cuenta regresiva para realizar la compra.',
      error7: 'La Fase 3 ha terminado, por favor espere el inicio de la Fase 4',
      tip1: 'DLC aún no distribuido',
      tip2: 'DLC ha sido distribuido a la billetera del usuario',
      tip3: 'Pago exitoso',
    },
    rule: {
      title: 'Descripción de las reglas',
      text1: 'La verificación KYC es obligatoria y requiere la presentación de documentos de identificación como DNI, pasaporte o licencia de conducir. Los residentes de Singapur, China, Estados Unidos, Corea del Sur y algunos otros países no pueden participar en el IDO.',
      text2: 'Después del final de la venta pública, el DLC se incluirá en las bolsas DEX dentro de 7 días y en las bolsas CEX dentro de 15 días. La dirección del contrato inteligente del token DLC en la cadena BSC es: 0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC',
      text3: 'La compra de 20,000,000 DLC le otorga una máquina de minería de juegos DeepLink doméstica con GPU valorada en 1500 dólares. Esta oferta está limitada a Japón y Europa, y los detalles de envío se notificarán por correo electrónico.',
      text3_btn: 'Más información sobre la máquina de minería de juegos con GPU doméstica',
      text4: 'La venta pública se cerrará 48 horas después de su inicio, y el precio de cada DLC es de 0.003 USDT. El 40% de los tokens permanecerán desbloqueados y el 60% restante se desbloqueará gradualmente a partir del 31 de agosto de 2024. Tenga en cuenta que: el 40% del DLC se transferirá a la dirección de su billetera especificada unos minutos después de la compra, y el 60% restante se transferirá a su billetera al vencer el bloqueo.',
      text5: 'La Public Sale se llevará a cabo en 5 etapas,',
      table: {
        table1_text1: 'fase',
        table1_text2: '2024/06/05-06/07',
        table1_text3: '2024/06/09-06/29',
        table1_text4: '2024/06/29-07/13',
        table1_text5: '2024/07/13-08/05',
        table1_text6: '2024/08/05-09/11',
        table2_text1: 'Cantidad de DLC',
        table2_text2: '350,000,000DLC',
        table2_text3: '400,000,000DLC',
        table2_text4: '300,000,000DLC',
        table2_text5: '450,000,000DLC',
        table2_text6: 'TBA',
        table3_text1: 'Precio de DLC (USDT)',
        table3_text2: '0.003',
        table3_text3: '0.003',
        table3_text4: '0.003',
        table3_text5: '0.003',
        table3_text6: '0.003',
        table4_text1: 'Bonificación',
        table4_text2: 'Bonificación adicional del 20% de DLC',
        table4_text3: 'Bonificación adicional del 15% de DLC',
        table4_text4: 'Bonificación adicional del 10% de DLC',
        table4_text5: 'Bonificación adicional del 5% de DLC',
        table4_text6: 'NO',
        table5_text1: 'Cantidad',
        table5_text2: '1,050,000 USDT',
        table5_text3: '1,200,000 USDT',
        table5_text4: '900,000 USDT',
        table5_text5: '1,350,000 USDT',
        table5_text6: 'TBA'
      }
    },
    ecology: {
      title: 'Visión general del ecosistema de DeepLink Protocol',
      block1_title: 'Software de DeepLink',
      block1_text1: 'La función principal del software de DeepLink es el control remoto y la plataforma de juegos en la nube',
      block1_text2: 'DeepLink Protocol incluye DeepLink Protocol y DeepLink Software. En su núcleo, DeepLink Software ofrece control remoto y funciones de juegos en la nube, permitiendo a los usuarios participar en juegos remotos, trabajo remoto y acceso a servicios de juegos en la nube. Actualmente, este software cuenta con una base de usuarios en 110 países, con más de 400,000 descargas y más de 200,000 carteras creadas a nivel mundial.',
      block1_btn1: 'Conocer el software de DeepLink',
      block2_title: 'Cibercafé en la nube y eSports en la nube',
      block2_text1: 'El cibercafé en la nube representa un modelo innovador de servicios de cibercafé y eSports, utilizando la tecnología de renderizado de ultra baja latencia de DeepLink Protocol.',
      block2_text2: 'En esta configuración, los juegos y aplicaciones se alojan en servidores de GPU en la nube en lugar de computadoras locales, permitiendo a los usuarios acceder y jugar a través de servicios en la nube sin necesidad de un equipo local de alto rendimiento. Los cibercafés en la nube basados en la tecnología DeepLink se están implementando en varios países, incluyendo Corea del Sur, China, Japón, Vietnam, Filipinas e India, con la participación de HYCONS, ZESTCLOUD, GLOWSTEAM y TIKEREN. Ya existe un caso operativo en Corea del Sur.',
      block2_btn1: 'Ver video',
      block2_btn2: 'Conocer los cibercafés en la nube',
      block3_title: 'Consola de juegos en la nube basada en blockchain',
      block3_text1: '¿Qué es una consola de juegos en la nube?',
      block3_text2: 'La consola de juegos en la nube basada en blockchain representa un avance en el hardware de juegos, ofreciendo una alta tasa de refresco de FPS para una experiencia de juego eSports sin interrupciones. Desarrollada por el grupo HKC, la consola de juegos en la nube TIKEREN utiliza la tecnología de renderizado de ultra baja latencia de DeepLink, conectándose en tiempo real a servidores de GPU en la nube para mejorar el rendimiento del renderizado de juegos.',
      block3_btn1: 'Conocer la consola de juegos en la nube basada en blockchain',
      block4_title: 'Consola portátil de juegos en la nube basada en blockchain',
      block4_text1: '¿Qué es una consola portátil de juegos en la nube?',
      block4_text2: 'La consola portátil de juegos en la nube basada en la tecnología de renderizado de ultra baja latencia de DeepLink ofrece una opción más rentable en comparación con las consolas portátiles tradicionales, proporcionando al mismo tiempo una experiencia de juego AAA fluida. Al conectarse a servidores de GPU en la nube para el renderizado de juegos en tiempo real, reduce el costo de la consola portátil en un 70%.',
      block4_btn1: 'Conocer la consola portátil de juegos en la nube basada en blockchain',
    },
    coverage: {
      title: 'Mapa de distribución de usuarios globales del software DeepLink',
      text: 'Número total de usuarios de DeepLink:'
    },
    track: {
      title: 'DeepLink Protocol es una combinación de DePIN+AI+Game',
      text: 'Pertenece a los campos más populares de la industria blockchain actual',
      block1_title: '¿Cuál es la magnitud del mercado de DeepLink?',
      block1_text: 'Una de las funciones de DeepLink se puede entender como una versión descentralizada de XBOX y PlayStation. Hasta finales de 2023, las ventas globales de la PS5 de Sony alcanzaron los 50 millones de unidades y las de Xbox Series X|S alcanzaron los 30 millones de unidades. Las ventas totales de PS y Xbox superaron los 200 millones de unidades, lo que demuestra que el mercado de juegos AAA de alta gama es enorme.',
      block2_title: 'DeepLink, al igual que XBOX y PlayStation, también atiende a jugadores de juegos AAA de alta gama, pero su modelo de negocio es completamente diferente',
      block2_text: 'Los jugadores de DeepLink no necesitan comprar consolas de juegos de alta gama. Solo necesitan descargar el software de DeepLink o comprar una consola de juegos en la nube basada en blockchain o una consola portátil de juegos en la nube basada en blockchain. Los jugadores pueden disfrutar de una experiencia de juego AAA similar a la de XBOX y PlayStation, pero ahorran el 80% del costo del hardware.',
      block3_title: 'Los mineros proporcionan consolas de juegos AAA de alta gama, que son sistemas Windows y compatibles con todos los juegos AAA de Windows.',
      block3_text: 'Las consolas de juegos de los mineros pueden estar en casa o en centros de datos. Las consolas de Xbox y PlayStation solo pueden ser usadas por sus propietarios y no se pueden alquilar a otros, lo que resulta en una baja eficiencia de uso y un gran desperdicio de recursos. La máquina de minería de juegos de DeepLink puede ser compartida con cualquiera, mejorando la utilización de los recursos de hardware y ofreciendo un nuevo modelo de negocio.',
      block4_title: 'Los mineros que proporcionan máquinas de minería de juegos pueden obtener recompensas en tokens DLC',
      block4_text: 'Esto incentiva a más mineros a proporcionar máquinas de minería de juegos. Los usuarios necesitan pagar con tokens DLC para comprar tiempo de juego, expandiendo así los escenarios de uso de DLC y aumentando la cantidad de personas que poseen tokens. El tamaño del mercado potencial de usuarios supera los mil millones de personas.',
      table: {
        table1_text1: 'Comparación detallada',
        table1_text2: 'Deep Link',
        table1_text3: 'Xbox',
        table1_text4: 'PS5',
        table2_text1: 'Jugar juegos AAA',
        table2_text2: 'Los usuarios no necesitan comprar hardware, solo descargar el software de DeepLink',
        table2_text3: 'Los usuarios necesitan comprar hardware',
        table2_text4: 'Los usuarios necesitan comprar hardware',
        table3_text1: 'Consola de juegos',
        table3_text2: 'Se puede alquilar para ganar $DLC, se puede alquilar más de 12 horas al día, se recupera en 10 meses',
        table3_text3: 'Solo puede ser usada por el propietario, no se puede alquilar, se usa de 2 a 4 horas al día, recursos de hardware desperdiciados',
        table3_text4: 'Solo puede ser usada por el propietario, no se puede alquilar, se usa de 2 a 4 horas al día, recursos de hardware desperdiciados',
        table4_text1: 'Consola portátil',
        table4_text2: 'Compatible, se puede conectar a cualquier hardware',
        table4_text3: 'No tiene consola portátil dedicada',
        table4_text4: 'Compatible, solo se puede conectar a PS5',
        table5_text1: 'Consola de juegos en la nube',
        table5_text2: 'Compatible',
        table5_text3: 'No compatible',
        table5_text4: 'No compatible',
        table6_text1: 'Cibercafé en la nube',
        table6_text2: 'Compatible',
        table6_text3: 'No compatible',
        table6_text4: 'No compatible',
      },
      btn1: 'DeepLink Software',
      btn2: 'DeepLink Protocol',
      btn3: 'Introducción del equipo',
      btn4: 'Modelo económico'
    },
    faqs: {
      title: 'FAQS',
      text: 'Puede que tenga preguntas, nosotros tenemos respuestas.',
      ques_title1: '1. ¿Qué es la Public Sale?',
      ques_text1: 'Durante la Public Sale, se venderá una cantidad limitada de tokens a un precio determinado a personas que deseen participar temprano. Esta es una gran oportunidad para convertirse en parte de DeepLink antes del lanzamiento real del token. Al participar en la Public Sale, puede comprar tokens a un precio temprano antes de su oferta pública. Por lo tanto, la Public Sale puede considerarse una oportunidad potencial para comprar tokens antes de que entren en circulación y se coticen en los intercambios.',
      ques_title2: '2. ¿Por qué estamos realizando una Public Sale?',
      ques_text2_1: 'Estamos realizando la Public Sale para construir una comunidad fuerte de poseedores de $DLC, mejorar nuestra plataforma y recaudar fondos para atraer a más jugadores a nuestro ecosistema.',
      ques_text2_2: 'Los fondos recaudados durante la Public Sale se reinvertirán continuamente en productos DeepLink, introduciendo nuevas funciones y ampliando la base de usuarios a través de actividades de marketing. Esto nos permitirá ejecutar nuestra estrategia de promoción de mercado antes del lanzamiento del token $DLC.',
      ques_text2_3: 'Nuestro objetivo es que 1,000,000,000 personas utilicen DeepLink, lo que proporcionará amplios escenarios de uso para el token $DLC y garantizará el éxito a largo plazo del token $DLC. El token $DLC se listará en intercambios DEX y CEX, impulsando aún más el crecimiento del ecosistema DeepLink.',
      ques_text2_4: '¡Únase ahora a la Public Sale de DeepLink y conviértase en parte de DeepLink!',
      ques_title3: '3. ¿Cuál es la diferencia entre DeepLink Protocol y DeepLink Software?',
      ques_text3_1: 'DeepLink Protocol es un protocolo de juegos en la nube AI descentralizado que combina tecnologías de AI y blockchain para proporcionar una tecnología de renderizado de juegos de ultra baja latencia.',
      ques_text3_2: 'DeepLink Software es un software de control remoto de juegos y una plataforma de juegos en la nube desarrollada sobre DeepLink Protocol.',
      ques_text3_3: 'Otros productos desarrollados sobre DeepLink Protocol incluyen una plataforma de cibercafé en la nube, una consola de juegos en la nube basada en blockchain y una consola portátil de juegos en la nube basada en blockchain, entre otros.',
      ques_title4: '4. ¿En qué se encuentra la innovación de DeepLink Protocol?',
      ques_text4: 'DeepLink resuelve las dificultades clave que enfrenta la industria de los juegos en la nube mediante el uso de tecnología blockchain y AI, y atrae a mineros y máquinas GPU inactivas a través de un mecanismo de incentivos con tokens. También atrae ancho de banda inactivo para resolver los dos problemas críticos en la industria de los juegos en la nube. La tecnología AI mejora la calidad gráfica del juego, mejorando la experiencia del usuario.',
      ques_title5: '5. ¿Qué es el $DLC Token?',
      ques_text5: 'El $DLC Token es el único medio de pago en el ecosistema DeepLink. Los usuarios deben pagar con $DLC Token para comprar tiempo de juego en la nube, alquilar computadoras para juegos en la nube, comprar licencias y más.',
      ques_title6: '6. ¿Quiénes son los clientes objetivo de DeepLink Protocol?',
      ques_text6_1: '1) Empresas de juegos AAA: Ayuda a convertir los juegos AAA en juegos en la nube, permitiendo que los juegos AAA funcionen en cualquier dispositivo de gama baja, incluyendo teléfonos móviles, aumentando la base de usuarios de juegos AAA en más de 10 veces.',
      ques_text6_2: '2) Cibercafés y hoteles de eSports: Ayuda a actualizar los cibercafés tradicionales transformándolos en cibercafés en la nube, reduciendo la inversión en hardware en más del 80% y aumentando las ganancias netas en 3 veces en 4 años.',
      ques_text6_3: '3) Fabricantes de hardware de consolas de juegos en la nube: Los fabricantes pueden integrar DeepLink Protocol, permitiendo jugar juegos AAA con una configuración de CPU de gama baja y una pantalla de juegos de alta gama, ahorrando a los jugadores el 80% de la inversión en hardware.',
      ques_text6_4: '4) Fabricantes de consolas portátiles de juegos en la nube: Los fabricantes pueden integrar DeepLink Protocol, lo que hace que el precio de la consola portátil sea el 30% del precio de una consola tradicional, con un rendimiento de juego más de 5 veces superior al de una consola portátil tradicional.',
      ques_title7: '7. ¿Quiénes son los clientes objetivo de DeepLink Software?',
      ques_text7: 'Son 3 mil millones de jugadores potenciales en todo el mundo, permitiendo a los jugadores disfrutar de juegos AAA de alta gama en sus teléfonos móviles, computadoras de bajo rendimiento, Mac y televisores.',
      ques_title8: '8. ¿Tiene un período de adquisición?',
      ques_text8: 'El 40% de los DLC Tokens comprados no están bloqueados, el 60% se desbloqueará en un período de 150 días a partir de aproximadamente el 31 de agosto de 2024, con un desbloqueo del 10% cada 30 días.',
      ques_title9: '9. ¿Cómo comprar $DLC?',
      ques_text9: 'Primero participe en la KYC, envíe su información personal y, una vez aprobado, podrá participar en la compra de $DLC cuando comience la Public Sale.',
    },
    buy: {
      title: '¿Cómo comprar?',
      step1: 'Paso 1:',
      step1_text: 'Conecte su billetera Metamask o Trust Wallet',
      step2: 'Paso 2:',
      step2_text: 'Confirme la transacción. Puede usar USDT para comprar $DLC',
      step3: 'Paso 3:',
      step3_text: 'Puede reclamar su $DLC después de que finalice la venta pública',
      btn1: 'Necesita ayuda',
      btn2: 'Comprar DLC',
    },
    potential: {
      title: 'Growth Potential', 
      text1_1: 'El valor de mercado de múltiples tokens en el sector DePIN ha seguido creciendo después de su cotización en las bolsas.',
      text1_2: '$ 888',
      text1_3: '$ 2288',
      text1_4: '$ 5888',
      text1_5: '$ 12888',
      text2: 'DeepLink Software tiene un mercado potencial de más de mil millones de usuarios, lo que llevará a una gran cantidad de usuarios de web2 al mundo de web3. El número potencial de poseedores de $DLC supera los mil millones de personas.',
      text3: 'Hay más de 200,000 cibercafés de eSports en todo el mundo. En el futuro, más del 50% de los cibercafés tradicionales se convertirán en cibercafés en la nube. La tecnología de los cibercafés en la nube tiene un amplio potencial de aplicación y cada cibercafé en la nube necesitará usar $DLC para los pagos, lo que resultará en un uso masivo de $DLC.',
      text4: 'Basándonos en las cifras de ventas de XBOX y PS5, el número de usuarios que compran consolas de juegos en la nube basadas en blockchain y consolas portátiles de juegos en la nube superará los 100 millones, lo que aportará un enorme valor a $DLC.'
    },
    report: {
      title: 'DeepLink en los Medios'
    },
    prompt: {
      title: 'Aviso de Información',
      text1: 'DeepCloudX.PTE.LTD opera el sitio web deeplink.cloud ("la plataforma").',
      text2: 'Al usar esta plataforma, acepta nuestros términos de servicio, política de privacidad, política de cookies y acuerdo de venta de tokens DLC. En su jurisdicción, las criptomonedas pueden no estar reguladas. El valor de las criptomonedas puede subir o bajar. Las ganancias pueden verse afectadas por el impuesto a las ganancias de capital u otros impuestos aplicables en su jurisdicción. Nada en este sitio web debe interpretarse como una oferta o recomendación para comprar, vender o invertir. Usted es el único responsable de determinar si cualquier compra o transacción relacionada es adecuada para usted, de acuerdo con sus objetivos personales, situación financiera y tolerancia al riesgo.',
      text3: 'Debe consultar a profesionales legales y asesores confiables y con licencia para obtener asesoramiento legal, fiscal, de seguros o comercial. DLC no garantiza ningún rendimiento, resultado o retorno de capital de ninguna criptomoneda en este sitio web. Al acceder a este sitio web y a cualquiera de sus páginas, usted acepta estar sujeto al acuerdo de venta de DLC. Comprar criptomonedas implica riesgos y puede resultar en una pérdida parcial o total.'
    }
  },
  dialog1: {
    title: 'Enviar información KYC',
    text1: 'Subir información de identidad:',
    text2: 'Subir una foto sosteniendo el documento de identidad:',
    text3: 'Información frontal del documento de identidad, pasaporte o licencia de conducir',
    text4: 'Debe ser claramente visible el rostro y la información de identidad',
    text5: 'Cantidad de DLC que desea comprar:',
    text6: 'Dirección de la billetera certificada:',
    text7: 'Recibirá una recompensa de 1000 DLC después de aprobar la verificación KYC, y los DLC bloqueados durante la Public Sale también se enviarán a esta dirección de billetera',
    text7_1: 'Solo esta dirección puede ser utilizada para la compra de DLC después de la verificación KYC, no se puede usar una dirección de intercambio',
    text8: '¿Dónde crear una dirección de billetera DLC en la cadena DBC?',
    text9: 'O',
    text10: 'Ingrese su dirección de correo electrónico:',
    text11: 'Obtener código de verificación',
    text12: 'Ingrese el código de verificación:',
    text13: 'Reenviar en {secs} segundos',
    text14: '(Máximo 20,000,000 DLC, solo se puede comprar la cantidad aprobada por la verificación KYC cuando comience la Public Sale)',

    success1: '¡Código de verificación enviado!',
    success2: 'Información enviada con éxito, esperando revisión',
    error1: '¡Debe seleccionar un archivo de imagen!',
    error2: '¡El archivo de imagen no puede estar vacío!',
    error3: '¡El nombre de usuario no puede estar vacío!',
    error4: '¡La dirección de la billetera no puede estar vacía!',
    error5: '¡El correo electrónico no puede estar vacío!',
    error6: '¡Por favor, introduzca una dirección de correo electrónico válida!',
    error7: '¡El código de verificación no puede estar vacío!',
    error8: 'Error al enviar el código de verificación, inténtelo de nuevo más tarde.',
    error9: 'Error al agregar',
    error10: 'Código de verificación incorrecto, por favor inténtelo de nuevo',
    error11: 'Error al consultar la información del correo electrónico',
    error12: 'La cantidad de compra no puede ser mayor de 20,000,000',
    error13: 'El código de verificación ha caducado, por favor obtenga uno nuevo',
    error14: 'Información enviada con éxito, pero falló el envío del correo electrónico de confirmación',
    error15: 'Si no ha recibido el correo, por favor revise su carpeta de correo no deseado',
    error16: 'La imagen no puede exceder los 5 MB',
    error17: 'Por favor, no envíe datos de verificación KYC repetidamente',
    tip1: '(Aviso amistoso: La información personal se utiliza solo para la verificación KYC, no para otros fines)',
  },
  dialog2: {
    title: 'Comprar DLC',
    text1: 'Cantidad de DLC a comprar:',
    text2: 'Debe comprar al menos 150,000 DLC',
    text3: 'Seleccione la criptomoneda de pago:',
    text4: 'Ingrese la dirección de la billetera DLC en la cadena DBC:',
    text5: 'El 40% de los DLC se transferirán a esta dirección de billetera en unos minutos, y el 60% restante se transferirá a esta dirección de billetera cuando expire el bloqueo',
    text6: '¿Dónde crear una dirección de billetera DLC en la cadena DBC?',
    text7: 'O',
    text8: 'Equivalente en USDT:',
    text9: 'Seleccione el método de pago:',
    text9_1: 'Pagar con la billetera conectada actualmente',
    text9_2: 'Pagar con código QR',
    error1: 'La cantidad de DLC no puede estar vacía',
    error2: 'Por favor, introduzca un número',
    error3: 'La cantidad introducida debe ser mayor que 50,000',
    error4: 'La dirección de la billetera no puede estar vacía',
    error5: 'Error al crear el pedido',
    success1: 'Pago exitoso, los DLC se transferirán a su dirección de billetera en unos minutos, ¡por favor verifíquelo!',
    success2: 'Pago exitoso a través del enlace de redirección, los DLC se transferirán a su dirección de billetera en unos minutos, ¡por favor verifíquelo!',
    error6: 'La cantidad de USDT no puede estar vacía',
    error7: 'La cantidad de USDT no puede ser menor que 150',
    error8: 'La cantidad de USDT no puede ser mayor que 60,000',
    error9: 'El monto del pago no coincide con el monto previsto, por favor contacte al administrador para confirmar si es correcto',
  },
  dialog3: {
    title: 'Introducción a la Consola Todo-en-Uno',
    text1: '1. ¿Qué es una consola de juegos en la nube todo-en-uno?',
    text2: 'La consola de juegos en la nube todo-en-uno, en comparación con las consolas tradicionales todo-en-uno, cuenta con una pantalla de alta frecuencia de actualización de FPS, proporcionando una experiencia de juego fluida. La consola de juegos en la nube TIKEREN de HKC Group está desarrollada con tecnología DeepBrainChain + DeepLink y puede conectarse en tiempo real a potentes GPU remotas para renderizado y cálculo de juegos. La consola viene con un sistema Windows integrado y puede usarse para el trabajo y el entretenimiento normales, permitiendo la transmisión de juegos desde su propia GPU de alto rendimiento a través de DeepLink. Cuando no se dispone de una GPU de alto rendimiento, se puede conectar a una GPU remota de alto rendimiento a través de DeepLink para jugar juegos AAA, pagando una cantidad determinada de DLC Token por hora.',
    text3: '2. Demostración de la consola TIKEREN',
    table: {
      th: {
        text1: 'Proyecto',
        text2: '27 pulgadas',
        text3: '31.5 pulgadas',
      },
      td1: {
        text1: 'Mode Type',
        text2: 'MA27H13QC1',
        text3: 'MA27H13QC1'
      },
      td2: {
        text1: 'Color Category',
        text2: 'Black',
        text3: 'Black'
      },
      td3: {
        text1: 'Display Size',
        text2: '27 pulgadas',
        text3: '31.5 pulgadas',
      },
      td4: {
        text1: 'Aspect Ratio',
        text2: 'Wide (16:9)',
        text3: 'Wide (16:9)'
      },
      td5: {
        text1: 'Panel Type',
        text2: 'IPS',
        text3: 'VA'
      },
      td6: {
        text1: 'Panel Resolution',
        text2: 'QHD 2560*1440',
        text3: 'QHD 2560*1440'
      },
      td7: {
        text1: 'Panel Refresh Rate',
        text2: '180Hz (Max)',
        text3: '170Hz(Max)'
      },
      td8: {
        text1: 'Responese Time',
        text2: '1mS(MPRT) GTG 1ms',
        text3: '1ms(MPRT) GTG 1ms'
      },
      td9: {
        text1: 'Color Gamut',
        text2: 'DCIP3 90%',
        text3: 'DCIP3 90%'
      },
      td10: {
        text1: 'Mainboard Solution',
        text2: 'Intel® N100 Chipset',
        text3: 'Intel® N100 Chipset'
      },
      td11: {
        text1: 'CPU/Cooler',
        text2: 'Intel N100 3.4GHz',
        text3: 'Intel N100 3.4GHz'
      },
      td12: {
        text1: 'Memory',
        text2: 'DDR4 8GB(Option Max 32G)',
        text3: 'DDR4 8GB(Option Max 32G)'
      },
      td13: {
        text1: 'Hard Disk',
        text2: 'SSD 128G(Option Max 1T)',
        text3: 'SSD 128G(Option Max 1T)'
      },
      td14: {
        text1: 'OS',
        text2: 'Windows 10/11(0ption)',
        text3: 'Windows 10/11(0ption)'
      },
      td15: {
        text1: 'GPU',
        text2: 'Intel UHD Graphics',
        text3: 'Intel UHD Graphics'
      },
      td16: {
        text1: 'Rear Interface',
        text2: '1*DC Power Connector，1*RJ45(2.5G)，4* USB 3.0，1*Audio jacks',
        text3: '1*DC Power Connector，1*HDMIN，1*HDMI OUT，1*RJ45(2.5G)，4* USB 3.0,1*Audio iacks'
      },
      td17: {
        text1: 'Side Interface',
        text2: 'USB 2.0x2，Power Button x1',
        text3: 'USB 2.0x2，Power Button x1'
      },
      td18: {
        text1: 'Wi-Fi',
        text2: '2.4G~5GHz(Wi-Fi5)，BT(4.2)',
        text3: '2.4G~5GHz(Wi-Fi5)，BT(4.2)'
      },
      td19: {
        text1: 'Audio',
        text2: 'Built-in Speakers*2',
        text3: 'Built-in Speakers*2'
      },
      td20: {
        text1: 'Base/Stand',
        text2: 'HAS:VESA',
        text3: 'HAS:VESA'
      },
      td21: {
        text1: 'Pivot',
        text2: 'Arriba, abajo, izquierda, derecha, rotación de 90°, ajuste de altura',
        text3: 'Arriba, abajo, izquierda, derecha, rotación de 90°, ajuste de altura',
      },
      td22: {
        text1: 'Power',
        text2: '90W',
        text3: '90W'
      },
      td23: {
        text1: 'Game Screen lmprovement',
        text2: 'Free Sync, G-Sync',
        text3: 'Free Sync, G-Sync'
      }
    },
    btn: 'Entendido'
  },
  dialog4: {
    title: 'Introducción a la Consola de Juegos en la Nube Portátil',
    text1: '1. ¿Qué es una consola de juegos en la nube portátil?',
    text2: 'La consola de juegos en la nube portátil se diferencia de las consolas portátiles tradicionales porque está desarrollada con la tecnología de renderizado de ultra baja latencia de DeepLink, lo que permite una conexión en tiempo real a servidores GPU en la nube para un rendimiento de juego superior. Esto reduce los costos de la consola portátil en un 70% y permite una experiencia de juego fluida en juegos AAA. La consola portátil tiene Google Play integrado para descargar juegos de Android y también permite la transmisión de juegos desde su propia GPU de alto rendimiento en Windows/PS/XBOX. Si no dispone de una GPU de alto rendimiento, puede conectarse a una GPU remota de alto rendimiento a través de DeepLink para jugar juegos AAA, pagando una cantidad determinada de DLC Token por hora.',
    text3: '2. Demostración de la consola de juegos en la nube basada en blockchain',
    btn: 'Entendido'
  },
  dialog5: {
    title: 'Introducción a la Minería de Juegos en el Hogar con GPU',
    text1: '1. ¿Qué es una máquina de minería de juegos en el hogar con GPU?',
    text2: 'La máquina de minería de juegos con GPU incluye una GPU NVIDIA 4070 Super, un CPU Intel i7-13700F, 32 GB de RAM y 2 TB de espacio en disco SSD. Está equipada con software de minería y un sistema de gestión DeepLink. Cualquier persona puede colocar esta máquina en su hogar para ganar recompensas en DLC. Cada año se distribuyen 1,000 millones de tokens DLC como recompensas para todas las máquinas de minería de juegos, independientemente de si hay usuarios alquilando la máquina para jugar. Al configurar la máquina de minería de juegos con GPU para alquiler, se pueden obtener recompensas en DLC y ingresos por alquiler en DBC. Además, cuando no hay usuarios alquilando la máquina, se pueden minar otros tokens, generando ingresos las 24 horas del día.',
    text3: '2. Demostración de la máquina de minería de juegos en el hogar con GPU',
    text4: '3. Especificaciones',
    text5_1: 'With RTX4070 Super Graphics Card',
    text5_2: 'Core i7-13700F, 16 Cores, 24 Threads, Base 1.5/2.1 GHz, Max 4.1/5.1GHz;',
    text5_3: 'Graphics Card GeForce RTX4070 Supe12G. Support 3rd Gen Ray Tracing and 4th Tensor Core.',
    text5_4: 'RAM Dual DDR4, Max 64GB (32GB*2).',
    text5_5: 'Hard Drive Ports One M2 2280 NVME SSD, and support to add double 2.5" SATA hard drive.',
    text5_6: 'Ports 4*USB 3.2, 4* USB 2.0, 3*DisplayPort, 1*HDMI, 2*LAN, 1*Optical, 1*Audio, 1*DC-IN, 2*WiFi ports.',
    text5_7: 'Operating System Preinstall with Windows 11 Pro.',
    btn: 'Entendido'
  }
}